import React from "react";
import { Navigate } from "react-router-dom";

import {
  LOGIN_PAGE,
  SIGNUP_PAGE,
  PRODUCTS_PAGE,
  DASHBOARD_PAGE,
  STOCK_PAGE,
  BARCODE_PAGE,
  SALES_PAGE,
  SALES_HISTORY_PAGE,
  REFUND_PAGE,
  REFUNDS_HISTORY_PAGE,
  PROFILE_PAGE,
  INVOICE_PAGE,
  INVENTORY_PAGE,
  CLIENT_PAGE,
  COMPANY_PAGE,
  DEVIS_PAGE,
  BUYS_PAGE,
  BUYS_HISTORY_PAGE,
  DELIVERY_NOTE_PAGE,
  PURCHASE_PAGE,
  PURCHASE_ORDERS_PAGE,
  RECEPTION_PAGE,
  SUPPLIER_INVOICE_PAGE,
  SUPPLIER_PAYMENTS_PAGE,
  CUSTOMER_PAYMENTS_PAGE,
  SUPPLIER_PAGE,
  ENTREPOT_PAGE,
  CLIENT_FORM_PAGE,
  CATEGORY_PAGE,
  UM_PAGE,
  PRODUCTS_FORM_PAGE,
  COMMANDE_PAGE,
  TRANSPORTEUR_PAGE,
  CHECK_MANAGEMENT_PAGE,
  SALES_REPORT_PAGE,
  REGLEMENTS_PAGE,
  REGLEMENTS_REPORT_PAGE,
  LOT_PAGE,
  MOUVEMENT_STOCK_PAGE,
  NEW_INVOICE_PAGE,
  CUSTOMER_RETURNS_PAGE,
  CUSTOMER_RETURN_FORM_PAGE,
  CUSTOMER_RETURN_DETAIL_PAGE,
  RELEVE_COMPTE_PAGE,
  BALANCE_COMPTABLE_PAGE,
  GRAND_LIVRE_PAGE,
  SYNTHESE_COMPTABLE_PAGE,
  MODULES_PAGE,
  DASHBOARD_MODULE_PAGE,
  INVENTORY_MODULE_PAGE,
  SALES_MODULE_PAGE,
  PURCHASES_MODULE_PAGE,
  FINANCE_MODULE_PAGE,
  ACCOUNTING_MODULE_PAGE,
  REPORTS_MODULE_PAGE,
  SETTINGS_MODULE_PAGE,
  CLIENT_EDIT_PAGE,
  REGLEMENT_FORM_PAGE,
  POS_PAGE,
  CBL_PAGE,
  PAY_PAGE,
  PAY_FORM_NEW,
  PAY_FORM_EDIT,
  RETOUR_PAGE,
  BACKUPS_MODULE_PAGE,
  BACKUPS_PAGE,
  DALA_PAGE,
} from "./routeConstants";
import SaleForm from "../components/Sales/SalesForm";
import LoginForm from "../components/Auth/Login";
import ProductList from "../components/Products/ProductList";
import Dashboard from "../components/Dashboard";
import StockPage from "../components/Stock";
import { ROLE_ADMIN, ROLE_AGENT, ROLE_CAISSE } from "../helpers/constants";
import BarcodePage from "../components/Stock/BarcodePage";
import Landing from "../components/landing/Landing";
import ProfilePage from "../components/Profil/ProfilePage";
import InvoiceList from "../components/Factures/InvoiceListe/InvoiceList";
import InventoryPage from "../components/Inventory";
import ClientList from "../components/Client/ClientList";
import DevisList from "../components/Devis/DevisList";
import DeliveryList from "../components/BonLivraison/DeliveryListe";
import BuyForm from "../components/Purchase/BuysForm";
import BuysReport from "../components/Purchase/BuysReport";
import PurchasePage from "../components/Purchase/PurchasePage";
import ReceptionPage from "../components/Reception/ReceptionPage";
import SupplierInvoiceList from "../components/SupplierInvoice/SupplierInvoiceList";
import SupplierPaimentsList from "../components/Payments/SupplierPaimentsList";
import ClientPaimentsList from "../components/Payments/ClientPaimentsList";
import SupplierInvoiceSummary from "../components/SupplierInvoice/SupplierInvoiceSummary";
import EntrepotPage from "../components/Entrepot/EntrepotPage";
import ClientForm from "../components/Client/ClientForm";
import ProductForm from "../components/Products/ProductForm";
import CategorieList from "../components/Products/CategorieList";
import UnitesList from "../components/Products/UnitesList";
import BonCommandeList from "../components/Devis/BonCommandeList";
import TransporteurPage from "../components/Transporteur/TransporteurPage";
import DashboardEncaissements from "../components/Dashboard/DashboardEncaissements";
import VentesStatistiques from "../components/Dashboard/VentesStatistiques";
import NewInvoicePage from "../components/Factures/NewInvoicePage";
import CustomerReturnsList from "../components/RetourClient/CustomerReturnsList";
import CustomerReturnForm from "../components/RetourClient/CustomerReturnForm";
import CustomerReturnDetail from "../components/RetourClient/CustomerReturnDetail";
import { ReleveCompte, BalanceComptable, GrandLivre, SyntheseComptable } from "../components/Comptabilite";

// Module Components
import ModuleSelector from "../components/ModuleSelector/ModuleSelector";
import DashboardModule from "../components/ModuleWrappers/DashboardModule";
import InventoryModule from "../components/ModuleWrappers/InventoryModule";
import SalesModule from "../components/ModuleWrappers/SalesModule";
import PurchasesModule from "../components/ModuleWrappers/PurchasesModule";
import FinanceModule from "../components/ModuleWrappers/FinanceModule";
import AccountingModule from "../components/ModuleWrappers/AccountingModule";
import ReportsModule from "../components/ModuleWrappers/ReportsModule";
import SettingsModule from "../components/ModuleWrappers/SettingsModule";
import ReglementsList from "../components/ReglementClient/ReglementsList";
import ReglementReport from "../components/ReglementClient/ReglementReport";
import POSPage from "../components/Comptoire/POSPage";
import BonComptoireList from "../components/Comptoire/BonComptoireList";
import AvanceClientList from "../components/Comptoire/AvanceClientList";
import ReglementForm from "../components/Comptoire/ReglementForm";
import RetourClientList from "../components/Comptoire/CustomerReturnsList";
import BackupsModule from "../components/ModuleWrappers/BackupsModule";
import BackupsPage from "../components/Backups/BackupsPage";
import DalaModule from "../components/ModuleWrappers/DalaModule";

const authProtectedRoutes = [
  // Default redirect to modules
  {
    path: "/",
    component: <Navigate to="/modules" replace />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: POS_PAGE,
    component: <POSPage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN],
  },
  {
    path: CBL_PAGE,
    component: <BonComptoireList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN],
  },

  {
    path: PAY_PAGE,
    component: <AvanceClientList />,
    roles: [ROLE_CAISSE,ROLE_ADMIN],
  },
  {
    path: PAY_FORM_NEW,
    component: <ReglementForm />,
    roles: [ROLE_CAISSE, ROLE_ADMIN],
  },
  {
    path: PAY_FORM_EDIT,
    component: <ReglementForm />,
    roles: [ROLE_CAISSE, ROLE_ADMIN],
  },
  {
    path: RETOUR_PAGE,
    component: <RetourClientList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN],
  },
  // Module System Routes
  {
    path: MODULES_PAGE,
    component: <ModuleSelector />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: DASHBOARD_MODULE_PAGE,
    component: <DashboardModule />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: INVENTORY_MODULE_PAGE,
    component: <InventoryModule />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: SALES_MODULE_PAGE,
    component: <SalesModule />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: PURCHASES_MODULE_PAGE,
    component: <PurchasesModule />,
    roles: [ROLE_ADMIN],
  },
  {
    path: FINANCE_MODULE_PAGE,
    component: <FinanceModule />,
    roles: [ROLE_ADMIN],
  },
  {
    path: ACCOUNTING_MODULE_PAGE,
    component: <AccountingModule />,
    roles: [ROLE_ADMIN],
  },
  {
    path: REPORTS_MODULE_PAGE,
    component: <ReportsModule />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: SETTINGS_MODULE_PAGE,
    component: <SettingsModule />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: DALA_PAGE,
    component: <DalaModule />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },

  {
    path: BACKUPS_MODULE_PAGE,
    component: <BackupsModule />,
    roles: [ROLE_ADMIN],
  },

  // Legacy Routes (keep for backward compatibility)
  {
    path: SALES_PAGE,
    component: <SaleForm />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: PROFILE_PAGE,
    component: <ProfilePage />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: BACKUPS_PAGE,
    component: <BackupsPage />,
    roles: [ROLE_ADMIN],
  },
  {
    path: SUPPLIER_PAYMENTS_PAGE,
    component: <SupplierPaimentsList />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: CUSTOMER_PAYMENTS_PAGE,
    component: <ClientPaimentsList />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: SALES_REPORT_PAGE,
    component: <VentesStatistiques />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  
  {
    path: TRANSPORTEUR_PAGE,
    component: <TransporteurPage />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
 
  {
    path: INVENTORY_PAGE,
    component: <InventoryPage />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: PRODUCTS_PAGE,
    component: <ProductList />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: PRODUCTS_FORM_PAGE,
    component: <ProductForm />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },

  {
    path: CATEGORY_PAGE,
    component: <CategorieList />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },

  {
    path: UM_PAGE,
    component: <UnitesList />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },

  {
    path: ENTREPOT_PAGE,
    component: <EntrepotPage />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },

  {
    path: DASHBOARD_PAGE,
    component: <Dashboard />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: CLIENT_FORM_PAGE,
    component: <ClientForm />,
    roles: [ROLE_ADMIN],
  },
  {
    path: CLIENT_EDIT_PAGE,
    component: <ClientForm />,
    roles: [ROLE_ADMIN],
  },
  {
    path: CLIENT_PAGE,
    component: <ClientList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: DEVIS_PAGE,
    component: <DevisList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: COMMANDE_PAGE,
    component: <BonCommandeList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: BARCODE_PAGE,
    component: <BarcodePage />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: STOCK_PAGE,
    component: <StockPage />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: INVOICE_PAGE,
    component: <InvoiceList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: CUSTOMER_RETURNS_PAGE,
    component: <CustomerReturnsList/>,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
   {
    path: CUSTOMER_RETURN_FORM_PAGE,
    component: <CustomerReturnForm />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: CUSTOMER_RETURN_DETAIL_PAGE,
    component: <CustomerReturnDetail  />,
    roles: [ROLE_ADMIN, ROLE_AGENT],
  },
  {
    path: SUPPLIER_INVOICE_PAGE,
    component: <SupplierInvoiceList />,
    roles: [ROLE_ADMIN],

  },
  {
    path: PURCHASE_PAGE,
    component: <PurchasePage />,
    roles: [ROLE_ADMIN],
  },
  {
    path: SUPPLIER_PAGE,
    component: <SupplierInvoiceSummary />,
    roles: [ROLE_ADMIN],
  },
  {
    path: CLIENT_PAGE,
    component: <ClientList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: PURCHASE_ORDERS_PAGE,
    component: <BuyForm />,
    roles: [ROLE_ADMIN],
  },
  {
    path: BUYS_HISTORY_PAGE,
    component: <BuysReport />,
    roles: [ROLE_ADMIN],
  },
  {
    path: DELIVERY_NOTE_PAGE,
    component: <DeliveryList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: RECEPTION_PAGE,
    component: <ReceptionPage />,
    roles: [ROLE_ADMIN],
  },
  {
    path: REGLEMENTS_PAGE,
    component: <ReglementsList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: NEW_INVOICE_PAGE,
    component: <NewInvoicePage />,
    roles: [ROLE_ADMIN],
  },
  {
    path: REGLEMENTS_REPORT_PAGE,
    component: <ReglementReport />,
    roles: [ROLE_ADMIN],
  },

  {
    path: CHECK_MANAGEMENT_PAGE,
    component: <DashboardEncaissements />,
    roles: [ROLE_ADMIN],
  },

  // Comptabilité routes
  {
    path: RELEVE_COMPTE_PAGE,
    component: <ReleveCompte />,
    roles: [ROLE_ADMIN],
  },
  {
    path: BALANCE_COMPTABLE_PAGE,
    component: <BalanceComptable />,
    roles: [ROLE_ADMIN],
  },
  {
    path: GRAND_LIVRE_PAGE,
    component: <GrandLivre />,
    roles: [ROLE_ADMIN],
  },
  {
    path: SYNTHESE_COMPTABLE_PAGE,
    component: <SyntheseComptable />,
    roles: [ROLE_ADMIN],
  }

];

const publicRoutes = [
  { path: "/", exact: true, component: <LoginForm /> },
  
  { path: LOGIN_PAGE, component: <LoginForm /> },
];

export { authProtectedRoutes, publicRoutes };
